import { ArrowRight, Footprints, MapPin, Plus, Signpost, TramFront, Utensils } from 'lucide-react';
import {
  Button,
  DataTag,
  DayHeader,
  ItineraryRow,
  Leg,
  MoneyReadout,
  SectionHeader,
  TagGroup,
} from '../kit/index.ts';
import s from './Kit.module.css';

/**
 * Every Field Manual component with real sample content (the Kyoto day from the mockups). Follows
 * the system's light/dark and contrast settings; e2e/kit.spec.ts captures all four modes.
 */
export function Kit() {
  return (
    <main className={s.page}>
      <SectionHeader title="Day 06 / 10" kicker="// Kyoto · 11.08" variant="screen" />
      <SectionHeader title="Japan 2026" bracketed stripe />
      <SectionHeader title="Bookings" readout="Next 3" />

      <section className={s.block} aria-label="Day header and itinerary rows">
        <DayHeader
          flag="11.08"
          weekday="Sun"
          counter="Day 06 / 10"
          destination="// Kyoto"
          total="¥12,400"
          day={6}
          today
          spoken="Sunday 8 November, day 6 of 10, Kyoto, today"
        />
        <div>
          <ItineraryRow
            time="07:30"
            icon={MapPin}
            title="Fushimi Inari Taisha"
            subline="Visited 07:41–09:20 · 2.9 km walked"
            stopId="06-1"
            state="past"
          />
          <Leg icon={TramFront} text="Keihan · 18 min" />
          <ItineraryRow
            time="10:30"
            icon={MapPin}
            title="Kiyomizu-dera 清水寺"
            subline="// Higashiyama · 1 h 30"
            stopId="06-2"
            state="now"
            tags={[<DataTag key="open" label="Open" value="06–18" spoken="Open" />]}
          />
          <Leg icon={Footprints} text="7 min · 0.5 km" />
          <ItineraryRow
            time="12:30"
            icon={Utensils}
            title="Okutan Kiyomizu"
            subline="Yudofu lunch · reserved"
            stopId="06-3"
            tags={[<DataTag key="conf" label="Conf" value="OK-221" spoken="Confirmation code" />]}
            money={
              <MoneyReadout primary="¥6,600" secondary={['₱2,527', '€40.12']} status={{ kind: 'planned' }} />
            }
          />
        </div>
      </section>

      <section className={s.block} aria-label="Data tags">
        <TagGroup>
          <DataTag label="Gate" value="B12" tone="signal" spoken="Gate" />
          <DataTag label="Seat" value="26E" spoken="Seat" />
          <DataTag label="Due" value="11.10" tone="hazard" />
          <DataTag label="Mine" tone="mine" spoken="Personal, only you can see this" />
          <DataTag label="Note" value="Shoes off inside" readout={false} />
        </TagGroup>
      </section>

      <section className={s.block} aria-label="Money">
        <MoneyReadout primary="₱148,300" secondary={['€2,310']} variant="total" />
        <div className={s.inline}>
          <MoneyReadout primary="¥1,280" secondary={['₱490', '€7.62']} status={{ kind: 'paid' }} />
          <MoneyReadout primary="₱4,250" secondary={['€68.20']} status={{ kind: 'due', date: '01.06' }} />
          <MoneyReadout primary="¥3,000" secondary={['₱1,150', '€18.40']} variant="inline" />
        </div>
      </section>

      <section className={s.buttons} aria-label="Buttons">
        <Button variant="primary" icon={Plus}>
          Log expense
        </Button>
        <Button icon={ArrowRight}>Settle up</Button>
        <div className={s.inline}>
          <Button variant="ink" icon={Signpost}>
            Directions
          </Button>
          <Button variant="outline">Edit</Button>
          <Button size="small" icon={ArrowRight}>
            Small
          </Button>
          <Button disabled>Disabled</Button>
        </div>
        <Button variant="destructive">Delete trip</Button>
        <Button variant="ghost">Not now</Button>
      </section>
    </main>
  );
}
